import script from "./message-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./message-dialog.vue?vue&type=style&index=0&id=4f75d46a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f75d46a"]])

export default __exports__